import { ONGOING } from "../../data/portfolio";
import { Heading, Yellow, Green } from "./Primitives";

export default function OngoingOutput() {
  return (
    <div>
      <Heading>ls ~/ongoing --status</Heading>
      <div className="space-y-2">
        {ONGOING.map((p) => (
          <div key={p.slug}>
            <div className="flex flex-wrap items-baseline gap-2">
              <Yellow>{p.name}/</Yellow>
              <span className="text-neutral-600 text-[12px]">{p.tech.join(", ")}</span>
              <span className="text-neutral-500 text-[12px]">{p.progress}</span>
            </div>
            <div className="text-neutral-400">{p.desc}</div>
            <div className="h-1 w-40 bg-neutral-800 mt-1 overflow-hidden">
              <div className="h-full bg-amber-400" style={{ width: p.progress }} />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-2 text-neutral-600 text-[12px]">
        tip: <Green>cd ongoing</Green> then <Green>cat &lt;name&gt;</Green> for the full readme.
      </div>
    </div>
  );
}